export enum PtConsoleRoutes {
  LOADER = 'loader',
  FORBIDDEN = 'forbidden',
  LOGIN = 'login',
  ORGANIZATIONS = 'organizations',
  USERS = 'users',
  SECURITY_CENTER = 'security-center',
  PROFILE = 'profile',
  CHANGE_EMAIL = 'change-email',
  CHANGE_PASSWORD = 'change-password',
  CHANGE_EMAIL_CONFIRM = 'change-email-confirm',
  TOOLS = 'tools',
  CREATE = 'create', //todo merge with AppRoutes ??
  MANAGEMENT_TEMPLATE = 'management-template'
}
